import { render, staticRenderFns } from "./BreaksManagementWidgetWrapper.vue?vue&type=template&id=7a0c2505&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports